import env from '../config/env';
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

/**
 * Enregistre le SW, demande la permission (doit être appelé depuis un geste utilisateur),
 * crée la subscription push et la sauvegarde en base.
 * @returns {"granted"|"denied"|"default"|"unsupported"} état final
 */
export async function registerWebPush(userId) {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    return 'unsupported';
  }
  try {
    // 1. SW — lance l'enregistrement puis attend qu'il soit actif
    navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' });
    const reg = await navigator.serviceWorker.ready;

    // 2. Permission
    let permission = Notification.permission;
    if (permission === 'default') {
      permission = await Notification.requestPermission();
    }
    if (permission !== 'granted') return permission;

    // 3. Subscription (réutilise si elle existe déjà)
    let subscription = await reg.pushManager.getSubscription();
    if (!subscription) {
      const res = await fetch(`${env.baseUrlApi}/api/push/vapid-public-key`);
      if (!res.ok) throw new Error(`VAPID fetch ${res.status}`);
      const { publicKey } = await res.json();
      subscription = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey),
      });
    }

    // 4. Sauvegarde en base
    const saveRes = await fetch(`${env.baseUrlApi}/api/push/subscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId, subscription: subscription.toJSON() }),
      credentials: 'include',
    });
    if (!saveRes.ok) throw new Error(`Subscribe ${saveRes.status}`);

    // 5. Navigation depuis clic sur notif (message SW → app)
    navigator.serviceWorker.addEventListener('message', (e) => {
      if (e.data?.type === 'NAVIGATE' && e.data.link) {
        window.location.href = e.data.link;
      }
    });

    return 'granted';
  } catch (err) {
    console.error('[WebPush]', err.message);
    return 'error';
  }
}

/** Retourne l'état actuel de la permission sans rien demander */
export function getPushPermission() {
  if (!('Notification' in window)) return 'unsupported';
  return Notification.permission; // "default" | "granted" | "denied"
}
